<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        h5(v-for="item,idx in $t('sec1Items')")  {{item}}


  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec3Items')")
            h4 {{item.title}}
            p {{item.desc}}

  .u-mb-md

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Human",
    "pageDesc":"Human is Baianat initiative that calls for renunciation of racism and getting all the humans from all over the world to know more about each other and exchange culture.",
    "mantra":"Human",
    "mantraDesc":"Human is a movement that seeks global awareness about the importance of peace and the value of human beings. It calls for renunciation of any form of discrimination and aims to reinforce values like tolerance and cordiality in efforts to reduce inequalities and support goal 10.",
    "sec1":"We believe that...",
    "sec1Items":{
      "1":"Organizations should be celebrating the differences of its employees and promoting a culture of diversity where everyone enjoys an equal opportunity.",
      "2":"Communities should be a place where everyone feels safe to live in and acts of racism and violence against minorities should be criminalized. ",
      "3":"Individuals should be respecting the freedom of others. Acts of bullying and descrimination should be prohibited."
    },
    "sec2":"We aim to spread awareness globally about...",
    "sec2Items":{
      "1":{
        "title":"Gender equality",
        "desc":"As women are facing many challenges in their daily life. We aim to reduce that by raising a more aware generation that understands their rights and duties."
      },
      "2":{
        "title":"Balanced workplace",
        "desc":"As we are seeing more discrimination forms sneaking into the work environment especially seen in hiring processes and vogue termination decisions."
      },
      "3":{
        "title":"Minorities support",
        "desc":"So we could eradicate the hate speech and unfavorable acts and promote a culture of diversity within the communities we live in."
      }
    },
    "sec3":"How to support human?",
    "sec3Items":{
      "1":{
        "title":"Individuals",
        "desc":"Contributing to our initiative doesn't require more than just a share. Gaining one more voice helps us in influencing and reaching more circles of humans."
      },
      "2":{
        "title":"Companies",
        "desc":"Adopting our culture and organizing events that gets all your employees together and create more active members of the community."
      }
    }
  },
  "ar": {
    "pageTitle":"إنسان",
    "pageDesc":"إنسان هي مبادرة بيانات التي تنبذ العنصرية وتدعو البشر للتعرف على بعضهم وعلى الثقافات المختلفة التي ينتمون إليها.",
    "mantra":"إنسان",
    "mantraDesc":"إنسان هي مبادرة تهدف إلى تعزيز الوعي العالمي بقيمة البشر. فهي تدعو إلى التخلي عن أي شكل من أشكال التمييز، وتهدف إلى تعزيز القيم مثل التسامح والود في المجتمعات من أجل دعم الهدف 10.",
    "sec1":"نؤمن أن….",
    "sec1Items":{
      "1":"لابد أن  تدعم المنظمات الاختلافات بين موظفيها وتروج لثقافة التنوع حيث يتمتع الجميع داخل المنظمة بتكافؤ الفرص.",
      "2":"يجب على المجتمعات أن تؤسس مكانًا يشعر فيه الجميع بالأمان، وعليها أن تجرم أعمال العنصرية والعنف ضد الأقليات.",
      "3":"على كل فرد مسؤولية احترام حرية الآخرين، ويحظر أعمال التنمر والتمييز بكافة أشكالها."
    },
    "sec2":"نسعى إلى نشر الوعي عالميًا حول….",
    "sec2Items":{
      "1":{
        "title":"المساواة بين الجنسين",
        "desc":"تواجه النساء العديد من التحديات في حياتها اليومية العملية. نهدف إلى الحد من ذلك من خلال خلق جيل أكثر وعيًا بحقوقهم وواجباتهم."
      },
      "2":{
        "title":"التوازن في مكان العمل",
        "desc":"نرى دائمًا المزيد من أشكال التمييز تتسلل إلى بيئات العمل خاصة في عمليات التوظيف  وقرارات الفصل."
      },
      "3":{
        "title":"دعم الأقليات",
        "desc":"نعمل على القضاء على الكراهية والأفعال الغير مرغوب بها وتعزيز ثقافة التنوع داخل المجتمعات التي نعيش فيها."
      }
    },
    "sec3":"كيف تدعم مبادرة إنسان؟",
    "sec3Items":{
      "1":{
        "title":"الأفراد",
        "desc":"لا تتطلب المساهمة في المبادرة أكثر من مجرد المشاركة. يساعدنا الحصول على صوت واحد في التأثير على العديد من دوائر البشر وإمكانية الوصول إليها."
      },
      "2":{
        "title":"الشركات",
        "desc":"التأقلم مع ثقافتنا وتنظيم الفعاليات التي تجمع كل موظفيك معًا من أجل خلق أعضاء أكثر نشاطًا في المجتمع."
      }
    }
  }
}
</i18n>
